import React from "react";
import CodeBlock from "../Code";
const HealthDescription1 = () => {
  return (
    <>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3 className="sub-0">1. 카카오 간편인증 요청</h3>
          <p>
            국민건강보험 간편인증 API를 사용하기 위해 먼저 다음 URI를 POST
            방식으로 호출해야 합니다.
          </p>
          <CodeBlock code={`POST /cert/request/kakao`}></CodeBlock>
          <h3>Request</h3>
          <p>
            간편인증 요청에 필요한 요청헤더에 다음과 같은 파라미터를
            작성해야합니다.
          </p>
          <CodeBlock
            code={`
          [HTTP Request Header]
          {
                          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                          "x-ncp-apigw-api-key": accessKey,
          },`}
          ></CodeBlock>
          <p>
            간편인증 요창에 필요한 요청본문에 다음과 같은 파라미터를
            작성해야합니다.
          </p>

          <CodeBlock
            code={`
          application/x-www-from-urlencoded
          [HTTP Request Body]
          {
                  "name": "string",
                  "phone" : "string",
                  "birthday" :"string",
          }                                          }
          `}
          ></CodeBlock>
          <p>다음은 요청 본문 파라미터에 대한 설명입니다.</p>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col">Field</th>
                  <th scope="col">Type</th>
                  <th scope="col">필수여부</th>
                  <th scope="col">설명</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ color: `#CE4241` }}>name</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>인증자 이름</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>phone</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>인증자 핸드폰번호</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>birthday</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>인증자 생년월일</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>Response</h3>
          <p>간편인증에 요청을 하면 아래와 같은 데이터를 보냅니다</p>
          <p>다음은 정상적인 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <CodeBlock
            code={`
              Content-Type: application/json
              
              [HTTP Response Body]
              {
                  "code": "string",
                  "msg": "string",
                  "data": {
                      "txId": "string",
                      "cxId": "string",
                      "token": "string",
                      "reqTxId": "string"
                  },
                  "cookie_str": "string"
              }
              `}
          ></CodeBlock>
          <table class="table table-bordered" style={{ width: `100%` }}>
            <thead>
              <tr class="table-secondary">
                <th scope="col" style={{ width: `20%` }}>
                  Field
                </th>
                <th scope="col" style={{ width: `20%` }}>
                  Type
                </th>
                <th scope="col" style={{ width: `60%` }}>
                  설명
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ color: `#CE4241` }}>code</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>요청의 처리 상태를 나타내는 문자열입니다.</td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>msg</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>요청 처리에 대한 설명 메시지가 반환됩니다.</td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>data</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  성공 시 응답 데이터 객체로 txId, cxId, token, reqTxId 값을
                  포함합니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>cookie_str</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  세션을 유지하는 쿠키 문자열. 인증 과정에서 세션을 유지하기
                  위해 사용됩니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>data.txId</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  트랜잭션 ID. 인증 프로세스에서 사용되는 고유 식별자 입니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>data.cxId</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  클라이언트 ID. 클라이언트의 고유 식별자로, 인증 처리 시
                  사용됩니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>data.token</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  인증 토큰. 서버에서 발급된 인증 토큰으로, 이후 인증 과정에서
                  사용됩니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>data.reqTxId</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>요청 트랜잭션 ID. 해당 요청에 대한 고유 식별자입니다.</td>
              </tr>
            </tbody>
          </table>
          <h3 style={{ marginTop: `20px` }}>Error</h3>
          <p>다음은 오류가 발생한 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <h5>HTTP Status : 200</h5>
          <CodeBlock
            code={`[HTTP Response Body]
            {
              "code": "LOGIN_EASY_CERT_STEP1:FAILED_NOT_EXIST_OR_NO_CERT",
              "msg": "사용자 정보가 잘못 입력되었거나 간편인증 서비스에서 인증서를 발급받지 않아서 진행할 수 없습니다.",
              "data": {},
              "cookie_str": "string"
            }`}
          ></CodeBlock>
          <CodeBlock
            code={`[HTTP Response Body]
            {
              "code": "LOGIN_EASY_CERT_STEP1:FAILED_ETC",
              "msg": "오류 메시지",
              "data": {},
              "cookie_str": "string"
            }`}
          ></CodeBlock>
          <CodeBlock
            code={`[HTTP Response Body]
            {
              "code": "ERROR:FAILED_PARSING_COOKIE_STR",
              "msg": "cookie_str 파싱 실패. cookie_str을 확인해주세요.",
              "data": "",
              "cookie_str": "",
              "text": ""
            }`}
          ></CodeBlock>
          <table class="table table-bordered" style={{ width: `100%` }}>
            <thead>
              <tr class="table-secondary">
                <th scope="col" style={{ width: `20%` }}>
                  Field
                </th>
                <th scope="col" style={{ width: `20%` }}>
                  Type
                </th>
                <th scope="col" style={{ width: `60%` }}>
                  설명
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ color: `#CE4241` }}>code</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  요청의 처리 상태를 나타내는 코드. 성공 또는 오류 여부를
                  반환합니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>msg</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  요청 처리에 대한 설명 메시지로, 오류 원인 또는 처리 결과가
                  담깁니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>data</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  응답 데이터 객체. 성공 시 인증 관련 데이터를 포함하며, 실패 시
                  빈 객체 {} 가 반환됩니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>cookie_str</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>세션을 유지하기 위한 쿠키 문자열입니다.</td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>text</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>서베어서 받은 전체 응답 본문을 포함하는 문자열입니다.</td>
              </tr>
            </tbody>
          </table>
          <p>response body는 다음과 같은 내용으로 이루어져있습니다.</p>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>오류코드</h3>
          <p>간편인증 API의 오류 목록은 다음과 같습니다.</p>
          <CodeBlock
            code={`
          [HTTP Response Body]
          {
                  "error": {
                          "errorCode": "210",
                          "message": "Permission Denied",
                          "details": 오류 메세지                                                   }
          }`}
          ></CodeBlock>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col">http status</th>
                  <th scope="message">message</th>
                  <th scope="col">detail</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>210 </td>
                  <td>Permission Denied </td>
                  <td>유효하지 않은 API Key </td>
                </tr>
                <tr>
                  <td>420</td>
                  <td>Field required </td>
                  <td>Field required </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3 className="sub-1">2. 카카오 간편인증 확인</h3>
          <p>
            국민건강보험 간편인증 API를 사용하기 위해 먼저 다음 URI를 POST
            방식으로 호출해야 합니다.
          </p>
          <CodeBlock code={`POST /cert/confirm/kakao`}></CodeBlock>
          <h3>Request</h3>
          <p>
            간편인증 요청에 필요한 요청헤더에 다음과 같은 파라미터를
            작성해야합니다.
          </p>
          <CodeBlock
            code={`
          [HTTP Request Header]
          {
                          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                          "x-ncp-apigw-api-key": accessKey,
          },`}
          ></CodeBlock>
          <p>
            간편인증 요창에 필요한 요청본문에 다음과 같은 파라미터를
            작성해야합니다.
          </p>
          <CodeBlock
            code={`[HTTP Request Body]
          {
                  "name": "string",
                  "phone" : "string",
                  "birthday" :"string",
                  "cookie_str" : "string",
                  "req_tx_id" : "string",
                  "token" : "string",
                  "tx_id" : "string",
                  "cx_id" : "string"
          }                                          }
          `}
          ></CodeBlock>
          <p>다음은 요청 본문 파라미터에 대한 설명입니다.</p>
          <div class="table-responsive">
            <table class="table table-bordered" style={{ width: `100%` }}>
              <thead>
                <tr class="table-secondary">
                  <th scope="col" style={{ width: `15%` }}>
                    Field
                  </th>
                  <th scope="col" style={{ width: `15%` }}>
                    Type
                  </th>
                  <th scope="col" style={{ width: `15%` }}>
                    필수여부
                  </th>
                  <th scope="col" style={{ width: `55%` }}>
                    설명
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ color: `#CE4241` }}>name</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>간편인증에 필요한 인증자 이름</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>phone</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>간편인증에 필요한 인증자 핸드폰번호</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>birthday</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>간편인증에 필요한 인증자 생년월일</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>cookie_str</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>
                    <span style={{ color: `#CE4241`, fontWeight: `bold` }}>
                      /cret/request/kakao
                    </span>
                    <span style={{ marginLeft: `5px` }}>
                      의 응답값으로 받은 쿠키 문자열
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>req_tx_id</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>
                    <span style={{ color: `#CE4241`, fontWeight: `bold` }}>
                      /cert/request/kakao
                    </span>
                    <span style={{ marginLeft: `5px` }}>
                      의 응답값으로 받은
                    </span>
                    <span
                      style={{
                        color: `#CE4241`,
                        fontWeight: `bold`,
                        marginLeft: `5px`,
                      }}
                    >
                      data.reqTxId
                    </span>
                    <span style={{ marginLeft: `5px` }}>고유 식별자</span>
                  </td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>token</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>
                    <span style={{ color: `#CE4241`, fontWeight: `bold` }}>
                      /cert/request/kakao
                    </span>
                    <span style={{ marginLeft: `5px` }}>
                      의 응답값으로 받은
                    </span>
                    <span
                      style={{
                        color: `#CE4241`,
                        fontWeight: `bold`,
                        marginLeft: `5px`,
                      }}
                    >
                      data.token
                    </span>
                    <span style={{ marginLeft: `5px` }}>인증 토큰</span>
                  </td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>tx_id</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>
                    <span style={{ color: `#CE4241`, fontWeight: `bold` }}>
                      /cert/request/kakao
                    </span>
                    <span style={{ marginLeft: `5px` }}>
                      의 응답값으로 받은
                    </span>
                    <span
                      style={{
                        color: `#CE4241`,
                        fontWeight: `bold`,
                        marginLeft: `5px`,
                      }}
                    >
                      data.txId
                    </span>
                    <span style={{ marginLeft: `5px` }}>고유 식별자</span>
                  </td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>cx_id</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>
                    <span style={{ color: `#CE4241`, fontWeight: `bold` }}>
                      /cert/request/kakao
                    </span>
                    <span style={{ marginLeft: `5px` }}>
                      의 응답값으로 받은
                    </span>
                    <span
                      style={{
                        color: `#CE4241`,
                        fontWeight: `bold`,
                        marginLeft: `5px`,
                      }}
                    >
                      data.cxId
                    </span>
                    <span style={{ marginLeft: `5px` }}>고유 식별자</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>Response</h3>
          <p>간편인증에 요청을 하면 아래와 같은 데이터를 보냅니다</p>
          <p>다음은 정상적인 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <CodeBlock
            code={`
              [HTTP Response Body]
              {
                "code": "LOGIN_EASY_CERT_STEP2:SUCCESS",
                "msg" : "string",
                "cookie_str" : "string",
              }
              `}
          ></CodeBlock>
          <table class="table table-bordered" style={{ width: `100%` }}>
            <thead>
              <tr class="table-secondary">
                <th scope="col" style={{ width: `20%` }}>
                  Field
                </th>
                <th scope="col" style={{ width: `20%` }}>
                  Type
                </th>
                <th scope="col" style={{ width: `60%` }}>
                  설명
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ color: `#CE4241` }}>code</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  요청의 처리 상태를 나타내는 코드. 성공 또는 오류 여부를
                  반환합니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>msg</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  요청 처리에 대한 설명 메시지로, 오류 원인 또는 처리 결과가
                  담깁니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>cookie_str</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>세션을 유지하기 위한 쿠키 문자열입니다.</td>
              </tr>
            </tbody>
          </table>
          <h3 style={{ marginTop: `20px` }}>Error</h3>
          <p>다음은 오류가 발생한 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <h5>HTTP Status : 200</h5>
          <CodeBlock
            code={`[HTTP Response Body]
            {
              "code": "LOGIN_EASY_CERT_STEP2:FAILED_NOT_SIGNED",
              "msg": "휴대폰에서 인증 처리 전",
              "cookie_str": "string"
            }`}
          ></CodeBlock>
          <CodeBlock
            code={`[HTTP Response Body]
            {
              "code": "LOGIN_EASY_CERT_STEP2:FAILED_ETC",
              "msg": "오류 메시지",
              "cookie_str": "string"
            }`}
          ></CodeBlock>
          <CodeBlock
            code={`[HTTP Response Body]
            {
              "code": "ERROR:FAILED_PARSING_COOKIE_STR",
              "msg": "cookie_str 파싱 실패. cookie_str을 확인해주세요.",
              "cookie_str": ""
            }`}
          ></CodeBlock>
          <table class="table table-bordered" style={{ width: `100%` }}>
            <thead>
              <tr class="table-secondary">
                <th scope="col" style={{ width: `20%` }}>
                  Field
                </th>
                <th scope="col" style={{ width: `20%` }}>
                  Type
                </th>
                <th scope="col" style={{ width: `60%` }}>
                  설명
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ color: `#CE4241` }}>code</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  요청의 처리 상태를 나타내는 코드. 성공 또는 오류 여부를
                  반환합니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>msg</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  요청 처리에 대한 설명 메시지로, 오류 원인 또는 처리 결과가
                  담깁니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>cookie_str</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  세션을 유지하기 위한 쿠키 문자열입니다. 유효하지 않으면 빈
                  문자열이 반환됩니다.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>오류코드</h3>
          <p>간편인증 API의 오류 목록은 다음과 같습니다.</p>
          <CodeBlock
            code={`
          [HTTP Response Body]
          {
                  "error": {
                          "errorCode": "210",
                          "message": "Permission Denied",
                          "details": 오류 메세지                                                   }
          }`}
          ></CodeBlock>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col">http status</th>
                  <th scope="message">message</th>
                  <th scope="col">detail</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>210 </td>
                  <td>Permission Denied </td>
                  <td>유효하지 않은 API Key </td>
                </tr>
                <tr>
                  <td>420</td>
                  <td>Field required </td>
                  <td>Field required </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3 className="sub-2">3. 네이버 간편인증 요청</h3>
          <p>
            국민건강보험 간편인증 API를 사용하기 위해 먼저 다음 URI를 POST
            방식으로 호출해야 합니다.
          </p>
          <CodeBlock code={`POST /cert/request/naver`}></CodeBlock>
          <h3>Request</h3>
          <p>
            간편인증 요청에 필요한 요청헤더에 다음과 같은 파라미터를
            작성해야합니다.
          </p>
          <CodeBlock
            code={`
          [HTTP Request Header]
          {
                          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                          "x-ncp-apigw-api-key": accessKey,
          },`}
          ></CodeBlock>
          <p>
            간편인증 요창에 필요한 요청본문에 다음과 같은 파라미터를
            작성해야합니다.
          </p>
          <CodeBlock
            code={`[HTTP Request Body]
          {
                  "name": "string",
                  "phone" : "string",
                  "birthday" :"string",
          }                                          }
          `}
          ></CodeBlock>
          <p>다음은 요청 본문 파라미터에 대한 설명입니다.</p>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col">Field</th>
                  <th scope="col">Type</th>
                  <th scope="col">필수여부</th>
                  <th scope="col">설명</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ color: `#CE4241` }}>name</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>인증자 이름</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>phone</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>인증자 핸드폰번호</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>birthday</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>인증자 생년월일</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>Response</h3>
          <p>간편인증에 요청을 하면 아래와 같은 데이터를 보냅니다</p>
          <p>다음은 정상적인 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <CodeBlock
            code={`
              Content-Type: application/json
              
              [HTTP Response Body]
              {
                  "code": "string",
                  "msg": "string",
                  "data": {
                      "txId": "string",
                      "cxId": "string",
                      "token": "string",
                      "reqTxId": "string"
                  },
                  "cookie_str": "string"
              }
              `}
          ></CodeBlock>
          <table class="table table-bordered" style={{ width: `100%` }}>
            <thead>
              <tr class="table-secondary">
                <th scope="col" style={{ width: `20%` }}>
                  Field
                </th>
                <th scope="col" style={{ width: `20%` }}>
                  Type
                </th>
                <th scope="col" style={{ width: `60%` }}>
                  설명
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ color: `#CE4241` }}>code</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>요청의 처리 상태를 나타내는 문자열입니다.</td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>msg</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>요청 처리에 대한 설명 메시지가 반환됩니다.</td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>data</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  성공 시 응답 데이터 객체로 txId, cxId, token, reqTxId 값을
                  포함합니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>cookie_str</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  세션을 유지하는 쿠키 문자열. 인증 과정에서 세션을 유지하기
                  위해 사용됩니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>data.txId</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  트랜잭션 ID. 인증 프로세스에서 사용되는 고유 식별자 입니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>data.cxId</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  클라이언트 ID. 클라이언트의 고유 식별자로, 인증 처리 시
                  사용됩니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>data.token</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  인증 토큰. 서버에서 발급된 인증 토큰으로, 이후 인증 과정에서
                  사용됩니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>data.reqTxId</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>요청 트랜잭션 ID. 해당 요청에 대한 고유 식별자입니다.</td>
              </tr>
            </tbody>
          </table>
          <h3 style={{ marginTop: `20px` }}>Error</h3>
          <p>다음은 오류가 발생한 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <h5>HTTP Status : 200</h5>
          <CodeBlock
            code={`[HTTP Response Body]
            {
              "code": "LOGIN_EASY_CERT_STEP1:FAILED_NOT_EXIST_OR_NO_CERT",
              "msg": "사용자 정보가 잘못 입력되었거나 간편인증 서비스에서 인증서를 발급받지 않아서 진행할 수 없습니다.",
              "data": {},
              "cookie_str": "string"
            }`}
          ></CodeBlock>
          <CodeBlock
            code={`[HTTP Response Body]
            {
              "code": "LOGIN_EASY_CERT_STEP1:FAILED_ETC",
              "msg": "오류 메시지",
              "data": {},
              "cookie_str": "string"
            }`}
          ></CodeBlock>
          <CodeBlock
            code={`[HTTP Response Body]
            {
              "code": "ERROR:FAILED_PARSING_COOKIE_STR",
              "msg": "cookie_str 파싱 실패. cookie_str을 확인해주세요.",
              "data": "",
              "cookie_str": "",
              "text": ""
            }`}
          ></CodeBlock>
          <table class="table table-bordered" style={{ width: `100%` }}>
            <thead>
              <tr class="table-secondary">
                <th scope="col" style={{ width: `20%` }}>
                  Field
                </th>
                <th scope="col" style={{ width: `20%` }}>
                  Type
                </th>
                <th scope="col" style={{ width: `60%` }}>
                  설명
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ color: `#CE4241` }}>code</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  요청의 처리 상태를 나타내는 코드. 성공 또는 오류 여부를
                  반환합니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>msg</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  요청 처리에 대한 설명 메시지로, 오류 원인 또는 처리 결과가
                  담깁니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>data</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  응답 데이터 객체. 성공 시 인증 관련 데이터를 포함하며, 실패 시
                  빈 객체 {} 가 반환됩니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>cookie_str</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>세션을 유지하기 위한 쿠키 문자열입니다.</td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>text</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>서베어서 받은 전체 응답 본문을 포함하는 문자열입니다.</td>
              </tr>
            </tbody>
          </table>
          <p>response body는 다음과 같은 내용으로 이루어져있습니다.</p>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>오류코드</h3>
          <p>간편인증 API의 오류 목록은 다음과 같습니다.</p>
          <CodeBlock
            code={`[HTTP Response Body]
          {
                  "error": {
                          "errorCode": "210",
                          "message": "Permission Denied",
                          "details": 오류 메세지                                                   }
          }`}
          ></CodeBlock>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col">http status</th>
                  <th scope="message">message</th>
                  <th scope="col">detail</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>210 </td>
                  <td>Permission Denied </td>
                  <td>유효하지 않은 API Key </td>
                </tr>
                <tr>
                  <td>420</td>
                  <td>Field required </td>
                  <td>Field required </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/*  */}
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>Response</h3>
          <p>간편인증확인을 요청을 하면 아래와 같은 데이터를 보냅니다</p>
          <p>다음은 정상적인 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <CodeBlock
            code={`
        
              
              [HTTP Response Body]
              {
                "code": "string",
                "msg": "string",
                "auth_code": "string"
              }
              `}
          ></CodeBlock>
          <p>다음은 오류가 발생한 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <CodeBlock
            code={`

          [HTTP Response Body]
          {
                  "error": {
                          "errorCode": "210",
                          "message": "Permission Denied",
                          "details": 오류 메세지                                                   }
          }`}
          ></CodeBlock>
          <p>response body는 다음과 같은 내용으로 이루어져있습니다.</p>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col">JSON key</th>
                  <th scope="col">설명</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>code</td>
                  <td>인증결과코드</td>
                </tr>
                <tr>
                  <td> msg</td>
                  <td>확인 메시지</td>
                </tr>
                <tr>
                  <td> auth_code</td>
                  <td>인증에 필요한 기타 데이터</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>오류코드</h3>
          <p>간편인증 API의 오류 목록은 다음과 같습니다.</p>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col">http status</th>
                  <th scope="message">message</th>
                  <th scope="col">detail</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>210 </td>
                  <td>Permission Denied </td>
                  <td>유효하지 않은 API Key </td>
                </tr>
                <tr>
                  <td>420</td>
                  <td>Field required </td>
                  <td>Field required </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3 className="sub-3">4. 네이버 간편인증 확인</h3>
          <p>
            국민건강보험 간편인증 API를 사용하기 위해 먼저 다음 URI를 POST
            방식으로 호출해야 합니다.
          </p>
          <CodeBlock code={`POST /cert/confirm/naver`}></CodeBlock>
          <h3>Request</h3>
          <p>
            간편인증 요청에 필요한 요청헤더에 다음과 같은 파라미터를
            작성해야합니다.
          </p>
          <CodeBlock
            code={`
          [HTTP Request Header]
          {
                          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                          "x-ncp-apigw-api-key": accessKey,
          },`}
          ></CodeBlock>
          <p>
            간편인증 요창에 필요한 요청본문에 다음과 같은 파라미터를
            작성해야합니다.
          </p>
          <CodeBlock
            code={`
          application/x-www-from-urlencoded
          [HTTP Request Body]
          {
                  "name": "string",
                  "phone" : "string",
                  "birthday" :"string",
                  "cookie_str" : "string",
                  "req_tx_id" : "string",
                  "token" : "string",
                  "tx_id" : "string",
                  "cx_id" : "string"
          }                                          }
          `}
          ></CodeBlock>
          <p>다음은 요청 본문 파라미터에 대한 설명입니다.</p>
          <div class="table-responsive">
            <table class="table table-bordered" style={{ width: `100%` }}>
              <thead>
                <tr class="table-secondary">
                  <th scope="col" style={{ width: `15%` }}>
                    Field
                  </th>
                  <th scope="col" style={{ width: `15%` }}>
                    Type
                  </th>
                  <th scope="col" style={{ width: `15%` }}>
                    필수여부
                  </th>
                  <th scope="col" style={{ width: `55%` }}>
                    설명
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ color: `#CE4241` }}>name</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>간편인증에 필요한 인증자 이름</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>phone</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>간편인증에 필요한 인증자 핸드폰번호</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>birthday</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>간편인증에 필요한 인증자 생년월일</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>cookie_str</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>
                    <span style={{ color: `#CE4241`, fontWeight: `bold` }}>
                      /cret/request/naver
                    </span>
                    <span style={{ marginLeft: `5px` }}>
                      의 응답값으로 받은 쿠키 문자열
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>req_tx_id</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>
                    <span style={{ color: `#CE4241`, fontWeight: `bold` }}>
                      /cert/request/naver
                    </span>
                    <span style={{ marginLeft: `5px` }}>
                      의 응답값으로 받은
                    </span>
                    <span
                      style={{
                        color: `#CE4241`,
                        fontWeight: `bold`,
                        marginLeft: `5px`,
                      }}
                    >
                      data.reqTxId
                    </span>
                    <span style={{ marginLeft: `5px` }}>고유 식별자</span>
                  </td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>token</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>
                    <span style={{ color: `#CE4241`, fontWeight: `bold` }}>
                      /cert/request/naver
                    </span>
                    <span style={{ marginLeft: `5px` }}>
                      의 응답값으로 받은
                    </span>
                    <span
                      style={{
                        color: `#CE4241`,
                        fontWeight: `bold`,
                        marginLeft: `5px`,
                      }}
                    >
                      data.token
                    </span>
                    <span style={{ marginLeft: `5px` }}>인증 토큰</span>
                  </td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>tx_id</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>
                    <span style={{ color: `#CE4241`, fontWeight: `bold` }}>
                      /cert/request/naver
                    </span>
                    <span style={{ marginLeft: `5px` }}>
                      의 응답값으로 받은
                    </span>
                    <span
                      style={{
                        color: `#CE4241`,
                        fontWeight: `bold`,
                        marginLeft: `5px`,
                      }}
                    >
                      data.txId
                    </span>
                    <span style={{ marginLeft: `5px` }}>고유 식별자</span>
                  </td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>cx_id</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>
                    <span style={{ color: `#CE4241`, fontWeight: `bold` }}>
                      /cert/request/naver
                    </span>
                    <span style={{ marginLeft: `5px` }}>
                      의 응답값으로 받은
                    </span>
                    <span
                      style={{
                        color: `#CE4241`,
                        fontWeight: `bold`,
                        marginLeft: `5px`,
                      }}
                    >
                      data.cxId
                    </span>
                    <span style={{ marginLeft: `5px` }}>고유 식별자</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>Response</h3>
          <p>간편인증에 요청을 하면 아래와 같은 데이터를 보냅니다</p>
          <p>다음은 정상적인 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <CodeBlock
            code={`
              [HTTP Response Body]
              {
                "code": "LOGIN_EASY_CERT_STEP2:SUCCESS",
                "msg" : "string",
                "cookie_str" : "string",
              }
              `}
          ></CodeBlock>
          <table class="table table-bordered" style={{ width: `100%` }}>
            <thead>
              <tr class="table-secondary">
                <th scope="col" style={{ width: `20%` }}>
                  Field
                </th>
                <th scope="col" style={{ width: `20%` }}>
                  Type
                </th>
                <th scope="col" style={{ width: `60%` }}>
                  설명
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ color: `#CE4241` }}>code</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  요청의 처리 상태를 나타내는 코드. 성공 또는 오류 여부를
                  반환합니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>msg</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  요청 처리에 대한 설명 메시지로, 오류 원인 또는 처리 결과가
                  담깁니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>cookie_str</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>세션을 유지하기 위한 쿠키 문자열입니다.</td>
              </tr>
            </tbody>
          </table>
          <h3 style={{ marginTop: `20px` }}>Error</h3>
          <p>다음은 오류가 발생한 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <h5>HTTP Status : 200</h5>
          <CodeBlock
            code={`[HTTP Response Body]
            {
              "code": "LOGIN_EASY_CERT_STEP2:FAILED_NOT_SIGNED",
              "msg": "휴대폰에서 인증 처리 전",
              "cookie_str": "string"
            }`}
          ></CodeBlock>
          <CodeBlock
            code={`[HTTP Response Body]
            {
              "code": "LOGIN_EASY_CERT_STEP2:FAILED_ETC",
              "msg": "오류 메시지",
              "cookie_str": "string"
            }`}
          ></CodeBlock>
          <CodeBlock
            code={`[HTTP Response Body]
            {
              "code": "ERROR:FAILED_PARSING_COOKIE_STR",
              "msg": "cookie_str 파싱 실패. cookie_str을 확인해주세요.",
              "cookie_str": ""
            }`}
          ></CodeBlock>
          <table class="table table-bordered" style={{ width: `100%` }}>
            <thead>
              <tr class="table-secondary">
                <th scope="col" style={{ width: `20%` }}>
                  Field
                </th>
                <th scope="col" style={{ width: `20%` }}>
                  Type
                </th>
                <th scope="col" style={{ width: `60%` }}>
                  설명
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ color: `#CE4241` }}>code</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  요청의 처리 상태를 나타내는 코드. 성공 또는 오류 여부를
                  반환합니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>msg</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  요청 처리에 대한 설명 메시지로, 오류 원인 또는 처리 결과가
                  담깁니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>cookie_str</td>
                <td style={{ color: `#5DAE46` }}>String</td>
                <td>
                  세션을 유지하기 위한 쿠키 문자열입니다. 유효하지 않으면 빈
                  문자열이 반환됩니다.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
export default HealthDescription1;
